export default "__VITE_ASSET__DSMrYDRb__"